<template>
  <div class="suggestion-lists" data-track-as="searchSuggestions">
    <div
      v-for="(list, i) of localLists"
      :key="i"
      class="suggestion-lists__list"
    >
      <h3 class="suggestion-lists__title">{{ list.title }}</h3>
      <ul class="suggestion-lists__link-list">
        <li
          v-for="link of list.links"
          :key="link.title"
          class="suggestion-lists__item"
        >
          <a class="suggestion-lists__link" :href="link.target">{{
            link.label
          }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import isString from 'lodash/isString'

export default {
  name: 'SuggestionLists',
  props: {
    lists: {
      type: [Array, String],
      default: () => [],
    },
  },
  data() {
    return {
      localLists: [],
    }
  },

  created() {
    this.initLinks()
  },

  methods: {
    initLinks() {
      if (this.lists) {
        this.localLists = isString(this.lists)
          ? JSON.parse(this.lists)
          : this.lists
      }
    },
  },
}
</script>

<style>
.suggestion-lists {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-8);
  flex-wrap: wrap;
}

.suggestion-lists__list {
  flex: 0 1 calc(25% - var(--spacing-8));
}

.suggestion-lists__title {
  font-family: 'Open Sans', sans-serif;
  font-size: 15px;
  font-weight: bold;
  color: var(--c-primary-neutral-3);
  margin-bottom: var(--spacing-4);
}

.suggestion-lists__item {
  min-width: 200px;
}

.suggestion-lists__link-list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
  list-style: none;
}

.suggestion-lists__link {
  display: inline;
  font-weight: normal;
  word-break: break-word;
  color: var(--c-primary-neutral-3);
  border-bottom: 1px solid var(--c-primary-neutral-3);
}
</style>
